import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// #583 S6a: the ONE canonical token sheet, shared with the family app. Not a copy.
import '../../app/src/styles/tokens.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
